import React from 'react'

function CloudComputingServicesContent() {
    return (
        <div>
            <>
                <div className="services-content bg-gray default-padding">
                    <div className="container">
                        <div className="about-style-one-items">
                            <div className="row">
                                <div className="col-xl-7 col-lg-6">
                                    <div className="thumb-style-one">
                                        <img title='Microcode Software' src="static/img/cloudcomputing/1.webp" alt="Img Not Found" />

                                    </div>
                                </div>
                                <div className="col-xl-5 col-lg-6 pl-50 pl-md-15 pl-xs-15">
                                    <div className="about-style-one-info">
                                        <div className="content">
                                            <h2 className="title">
                                                Design That Drives Results
                                            </h2>
                                            <p>
                                                Microcode Software builds scalable, data-driven websites with AI features, and fast PWAs. We offer global reach with multilingual, multi-currency, and SEO-ready.  We have compliant, accessible, and WCAG compliant accessible sites built on a structured platform.
                                            </p>
                                        </div>
                                        <ul className="card-list">
                                            <li>
                                                <img title='Microcode Software' src="static/img/icon/4.png" alt="Img Not Found" />
                                                <h5>AI Integration</h5>
                                            </li>
                                            <li>
                                                <h2>3.8 X</h2>
                                                <h5>Scalable Architecture </h5>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="services-content default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h2 className="title">Frequently Asked Questions</h2>
                                <p>
                                    Microcode Software is one of the best web development companies in India. We set milestones for our competitors. While others focus on basic designs and templates, we work to go deeper to deliver websites that are visually stunning, functionally powerful, and strategically optimized.
                                </p>
                                <div className="accordion mt-50" id="faqAccordion">
                                    <div className="accordion-item accordion-style-one">
                                        <h2 className="accordion-header" id="headingOne">
                                            <button
                                                className="accordion-button"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne"
                                                aria-expanded="true"
                                                aria-controls="collapseOne"
                                            >
                                                What services do you offer in web development?

                                            </button>
                                        </h2>
                                        <div
                                            id="collapseOne"
                                            className="accordion-collapse collapse show"
                                            aria-labelledby="headingOne"
                                            data-bs-parent="#faqAccordion"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    We offer complete web development services, including custom design, development, e-commerce, CMS integration, SEO optimization, cloud hosting and AI-driven features. </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item accordion-style-one">
                                        <h2 className="accordion-header" id="headingTwo">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseTwo"
                                                aria-expanded="false"
                                                aria-controls="collapseTwo"
                                            >
                                                How long does it take to build my website?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseTwo"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingTwo"
                                            data-bs-parent="#faqAccordion"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    The period of your project depends on your project's requirements. On average, a standard website takes 4-6 weeks, while more complex sites may take 8-12 weeks.
                                                </p>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item accordion-style-one">
                                        <h2 className="accordion-header" id="headingThree">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseThree"
                                                aria-expanded="false"
                                                aria-controls="collapseThree"
                                            >
                                                What are the advantages of using cloud services like AWS or Google Cloud?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseThree"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingThree"
                                            data-bs-parent="#faqAccordion"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    Cloud services offer:
                                                </p>
                                                <ul className="list-style-two">
                                                    <li>Scalability to handle traffic spikes. </li>
                                                    <li>Robust security and compliance.</li>
                                                    <li>Global performance with low latency.</li>
                                                    <li>Cost-efficient infrastructure.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item accordion-style-one">
                                        <h2 className="accordion-header" id="headingFour">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseFour"
                                                aria-expanded="false"
                                                aria-controls="collapseFour"
                                            >
                                                Which technology brings maximum value to my business website?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseFour"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingFour"
                                            data-bs-parent="#faqAccordion"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    The technology that adds value to your business is based on your website's unique requirements and needs. We recommend the pair of React.js and Node.js with cloud platforms like AWS for high performance and scalability. For ease of use, WordPress and Webflow are excellent CMS options.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item accordion-style-one">
                                        <h2 className="accordion-header" id="headingFive">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseFive"
                                                aria-expanded="false"
                                                aria-controls="collapseFive"
                                            >
                                                Do you offer ongoing maintenance and updates?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseFive"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingFive"
                                            data-bs-parent="#faqAccordion"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    Absolutely! We guarantee that your website remains secure and up-to-date, so we provide 24/7 support, regular updates, and performance optimization.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </div>
    )
}

export default CloudComputingServicesContent
